/**
 * TanStack Router: /workforce/departments/$departmentId
 *
 * Department detail view showing department information, employees, budget, and org structure
 * Layout: Authenticated (_auth)
 *
 * @see src/app/workforce/departments/[id]/page.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import DepartmentDetailPage from '@/app/workforce/departments/[id]/page'

/**
 * Route: /workforce/departments/$departmentId
 * Layout: _auth (authenticated)
 * Component: DepartmentDetailPage
 */
export const Route = createFileRoute('/_auth/workforce/departments/$departmentId/')({
  component: DepartmentDetailPage,
})
